import { createStore } from 'vuex'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '../router'
export default createStore({
  state: {
    linkpage: [
      {
        // A
        content: [
          {
            title: '警方未到場',
            text: '擺放警告標誌',
            link: '/accident/a1'
          },
          {
            text: '打電話報警',
            link: '/accident/a2'
          },
          {
            text: '保護傷者',
            link: '/accident/a3'
          },
          {
            text: '保存證據',
            link: '/accident/a4'
          },
          {
            text: '通知保險公司',
            link: '/accident/a5'
          },
          {
            text: '國道高速公路車輛拖救服務廠商一覽表',
            link: '/accident/a6'
          },
          {
            text: '拖吊費率',
            link: '/accident/a7'
          },
          {
            text: '相關Q&A',
            link: '/accident/a8'
          }
        ]
      },
      {
        // B
        content: [
          {
            title: '警方到場後',
            text: '當事人登記聯單',
            link: '/accident/b1'
          },
          {
            text: '道路交通事故談話紀錄表',
            link: '/accident/b2'
          },
          {
            text: '道路交通事故調查報告表(一)',
            link: '/accident/b3'
          },
          {
            text: '道路交通事故調查報告表(二)',
            link: '/accident/b4'
          },
          {
            text: '相關Q&A',
            link: '/accident/b5'
          }
        ]
      },
      {
        // C
        content: [
          {
            title: '事故資料申請',
            text: '交通事故資料申請',
            link: '/procedure/c1'
          },
          {
            text: '交通事故資料申請書',
            link: '/procedure/c2'
          },
          {
            text: '網路申請及連結',
            link: '/procedure/c3'
          },
          {
            text: '道路交通事故現場圖',
            link: '/procedure/c4'
          },
          {
            text: '道路交通事故現場照片',
            link: '/procedure/c5'
          },
          {
            text: '初步分析研判表',
            link: '/procedure/c6'
          },
          {
            text: '道路交通事故當事人資料',
            link: '/procedure/c7'
          },
          {
            text: '相關Q&A',
            link: '/procedure/c8'
          }
        ]
      },
      {
        // D
        content: [
          {
            title: '車禍鑑定申請',
            text: '車禍鑑定流程圖',
            link: '/procedure/d1'
          },
          {
            text: '鑑定案件作業流程',
            link: '/procedure/d2'
          },
          {
            text: '全台受理車禍轄區地圖',
            link: '/procedure/d3'
          },
          {
            text: '車禍鑑定應備文件',
            link: '/procedure/d4'
          },
          {
            text: '全台鑑定會轄區範圍與窗口',
            link: '/procedure/d5'
          },
          {
            text: '車輛行車事故鑑定查詢',
            link: '/procedure/d6'
          },
          {
            text: '事故鑑定相關問題',
            link: '/procedure/d7'
          },
          {
            text: '車禍鑑定相關法規',
            link: '/procedure/d8'
          }// ,
          // {
          //   text: '相關Q&A',
          //   link: '/procedure/d9'
          // }
        ]
      },
      {
        // E
        content: [
          {
            title: '調解申請',
            text: '調解概念及流程',
            link: '/procedure/e1'
          },
          {
            text: '調解管轄',
            link: '/procedure/e2'
          },
          {
            text: '調解申請',
            link: '/procedure/e3'
          },
          {
            text: '調解應備文件及注意事項',
            link: '/procedure/e4'
          },
          {
            text: '相關Q&A',
            link: '/procedure/e5'
          }
        ]
      },
      {
        // F
        content: [
          {
            title: '車禍責任',
            text: '行政責任',
            link: '/compensation/f1'
          },
          {
            text: '刑事責任',
            link: '/compensation/f2'
          },
          {
            text: '民事責任',
            link: '/compensation/f3'
          },
          {
            text: '各地方法院管轄範圍查詢',
            link: '/compensation/f4'
          },
          {
            text: '相關Q&A',
            link: '/compensation/f5'
          }
        ]
      },
      {
        // G
        content: [
          {
            title: '賠償試算',
            text: '賠償明細項目',
            link: '/compensation/g1'
          }
        ]
      },
      {
        // H
        content: [
          {
            title: '保險理賠',
            text: '強制險',
            link: '/compensation/h1'
          },
          {
            text: '任意險',
            link: '/compensation/h2'
          },
          {
            text: '商業保險(意外險)',
            link: '/compensation/h3'
          },
          {
            text: '勞工保險',
            link: '/compensation/h4'
          },
          {
            text: '學生平安(團體)保險',
            link: '/compensation/h5'
          },
          {
            text: '相關Q&A',
            link: '/compensation/h6'
          }
        ]
      },
      {
        // I
        content: [
          {
            title: '法律扶助',
            text: '何謂法律扶助',
            link: '/compensation/i1'
          },
          {
            text: '法律扶助申請審查標準',
            link: '/compensation/i2'
          },
          {
            text: '法律扶助申請流程',
            link: '/compensation/i3'
          },
          {
            text: '法律扶助應備文件及注意事項',
            link: '/compensation/i4'
          },
          {
            text: '法律扶助項目',
            link: '/compensation/i5'
          },
          {
            text: '相關Q&A',
            link: '/compensation/i6'
          }
        ]
      },
      {
        // J
        content: [
          {
            title: '犯罪被害人保護',
            text: '何謂犯罪被害人保護',
            link: '/compensation/j1'
          },
          {
            text: '犯罪被害人保護申請權人',
            link: '/compensation/j2'
          },
          {
            text: '犯罪被害人保護補償金申請流程',
            link: '/compensation/j3'
          },
          {
            text: '犯罪被害人保護補償金應備文件及注意事項',
            link: '/compensation/j4'
          },
          {
            text: '相關Q&A',
            link: '/compensation/j5'
          }
        ]
      },
      {
        // K
        content: [
          {
            title: '社會福利',
            text: '身心障礙證明申請',
            link: '/compensation/k1'
          },
          {
            text: '身心障礙證明申請權人',
            link: '/compensation/k2'
          },
          {
            text: '身心障礙證明申請流程',
            link: '/compensation/k3'
          },
          {
            text: '身心障礙證明申請應備文件及注意事項',
            link: '/compensation/k4'
          },
          {
            text: '相關Q&A',
            link: '/compensation/k5'
          }
        ]
      },
      {
        // L
        content: [
          {
            title: '交通安全宣導影片',
            text: '警方到場前',
            link: '/safe/l1'
          },
          {
            text: '警方到場後',
            link: '/safe/l2'
          },
          {
            text: '交通事故資料申請',
            link: '/safe/l3'
          },
          {
            text: '車禍鑑定申請',
            link: '/safe/l4'
          },
          {
            text: '調解申請',
            link: '/safe/l5'
          },
          {
            text: '車禍責任',
            link: '/safe/l6'
          },
          {
            text: '賠償試算',
            link: '/safe/l7'
          },
          {
            text: '保險理賠',
            link: '/safe/l8'
          },
          {
            text: '法律扶助',
            link: '/safe/l9'
          },
          {
            text: '被害人保護',
            link: '/safe/l10'
          },
          {
            text: '社會福利',
            link: '/safe/l11'
          }
        ]
      },
      {
        // M
        content: [
          {
            title: '相關法規',
            text: '法律連結',
            link: '/safe/m1'
          }
        ]
      }
    ],
    nowPage: '',
    nowPagetitle: '',
    loginToken: '',
    loginState: false,
    newsTable: [],
    userInfo: {},
    consultVisible: false
  },
  mutations: {
    setPage (state, page) {
      state.nowPage = page
    },
    setPageTitle (state, title) {
      state.nowPagetitle = title
    },
    setloginToken (state, token) {
      state.loginToken = token
    },
    setloginState (state, status) {
      state.loginState = status
    },
    setUserInfo (state, info) {
      state.userInfo = info
    },
    setNewsTable (state, news) {
      state.newsTable = news
    },
    setConsultVisible (state, value) {
      state.consultVisible = value
    }
  },
  actions: {
    loginAndGetToken (context, body) {
      axios.post('https://api.guardian17681.com/user/login', body)
        .then((response) => {
          ElMessage({
            message: '登入成功，跳轉中...',
            type: 'success'
          })
          context.commit('setloginToken', response.data.token)
          context.commit('setloginState', true)
          context.dispatch('getUserInfo')
          setTimeout(() => {
            router.push('/')
          }, 2000)
        })
        .catch((error) => {
          console.log(error)
          ElMessage.error('登入失敗，請檢查您的帳號或密碼')
        })
    },
    getUserInfo (context) {
      axios.get('https://api.guardian17681.com/user/info', { headers: { Authorization: 'Bearer ' + context.state.loginToken } })
        .then((response) => {
          context.commit('setUserInfo', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  modules: {
  }
})
